/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Sort_NameInputs */

const en_us2_plan_build_sort_name = /** @type {(inputs: Plan_Build_Sort_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z`)
};

const pt_br2_plan_build_sort_name = /** @type {(inputs: Plan_Build_Sort_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z`)
};

const es_419_plan_build_sort_name = /** @type {(inputs: Plan_Build_Sort_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z`)
};

const pt_pt2_plan_build_sort_name = /** @type {(inputs: Plan_Build_Sort_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z`)
};

const fr_fr2_plan_build_sort_name = /** @type {(inputs: Plan_Build_Sort_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z`)
};

const de_de2_plan_build_sort_name = /** @type {(inputs: Plan_Build_Sort_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z`)
};

const it_it2_plan_build_sort_name = /** @type {(inputs: Plan_Build_Sort_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z`)
};

/**
* | output |
* | --- |
* | "A–Z" |
*
* @param {Plan_Build_Sort_NameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_sort_name = /** @type {((inputs?: Plan_Build_Sort_NameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Sort_NameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_sort_name(inputs)
	if (locale === "es-419") return es_419_plan_build_sort_name(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_sort_name(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_sort_name(inputs)
	if (locale === "de-DE") return de_de2_plan_build_sort_name(inputs)
	if (locale === "it-IT") return it_it2_plan_build_sort_name(inputs)
	return en_us2_plan_build_sort_name(inputs)
});
export { plan_build_sort_name as "plan-build.sort_name" }